"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ar_EG = _interopRequireDefault(require("../../date-picker/locale/ar_EG"));
var _default = exports["default"] = _ar_EG["default"];